/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Plan_RestrictedInputs */



/**
* | output |
* | --- |
* | "Your plan does not include this model. Switch models or upgrade your plan to continue." |
*
* @param {Chat_Error_Plan_RestrictedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_plan_restricted = /** @type {((inputs?: Chat_Error_Plan_RestrictedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Plan_RestrictedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein Plan enthält dieses Modell nicht. Wechsle das Modell oder upgrade deinen Plan, um fortzufahren.")
	return /** @type {LocalizedString} */ ("Your plan does not include this model. Switch models or upgrade your plan to continue.")
});